<template>
  <ScaleBox>
    <div class="mr-visual">
      <v-header-box></v-header-box>
      <div class="mr-visual-left">
        <div class="left-cards">
          <div class="data-card">
            <div style="height:15px;">&nbsp;</div>
            <div class="card-title">{{screenData.energyLabel}}</div>
            <div class="year-data">
              <div class="year-item">
                <span class="year-label">{{screenData.thisJson.year}}</span>
                <span class="year-value">{{screenData.thisJson.energy}}</span>
                <span :class=screenData.thisJson.energyColor style="margin-left:15px;font-size:22px;">{{screenData.thisJson.energyPercent}}&nbsp;<i style="font-size:22px;" :class=screenData.thisJson.energyClass></i></span>
              </div>
              <div class="year-item">
                <span class="year-label">{{screenData.prevJson.year}}</span>
                <span class="year-value">{{screenData.prevJson.energy}}</span>
              </div>
            </div>
            <div style="height:20px;">&nbsp;</div>
          </div>
          <div style="height:20px;">&nbsp;</div>
          <div class="data-card">
            <div style="height:20px;">&nbsp;</div>
            <div class="card-title">{{screenData.moneyLabel}}</div>
            <div class="year-data">
              <div class="year-item">
                <span class="year-label">{{screenData.thisJson.year}}</span>
                <span class="year-value">{{screenData.thisJson.money}}</span>
                <span :class=screenData.thisJson.moneyColor style="margin-left:15px;font-size:22px;">{{screenData.thisJson.moneyPercent}}&nbsp;<i style="font-size:22px;" :class=screenData.thisJson.moneyClass></i></span>
              </div>
              <div class="year-item">
                <span class="year-label">{{screenData.prevJson.year}}</span>
                <span class="year-value">{{screenData.prevJson.money}}</span>
              </div>
            </div>
            <div style="height:20px;">&nbsp;</div>
          </div>
          <div style="height:20px;">&nbsp;</div>
          <div class="data-card">
            <div style="height:20px;">&nbsp;</div>
            <div class="card-title">冷库信息</div>
            <div class="year-data">
              <div class="year-item">
                <span class="year-label2">A库面积</span>
                <span class="year-value">4956㎡</span>
              </div>
              <div class="year-item">
                <span class="year-label2">B库面积</span>
                <span class="year-value">4956㎡</span>
              </div>
              <div class="year-item">
                <span class="year-label2">A库PCM用量</span>
                <span class="year-value">50吨</span>
              </div>
              <div class="year-item">
                <span class="year-label2">B库PCM用量</span>
                <span class="year-value">50吨</span>
              </div>
            </div>
            <div style="height:20px;">&nbsp;</div>
          </div>
        </div>
      </div>
      <transition name="el-fade-in-linear">
        <div class="mr-visual-container">
          
        </div>
      </transition>
      <div class="mr-visual-right">
        <div class="right-cards">
          <div class="right-card">
            <div class="card-title">冷库温变曲线 
              <el-select v-model="deviceA" style="width:100px;" @change="loadKuwenData">
                <el-option label="A库" value="13517" />
                <el-option label="B库" value="13521" />
              </el-select>
            </div>
            <ECharts :options="kuwenOption" class="chart" :height="echartHeight" />
          </div>
          <div class="right-card">
            <div class="card-title">风机能耗曲线 
              <el-select v-model="paramEnergy.energyFlag" style="width:150px;" @change="loadEnergyData">
                <el-option label="小时能耗-kW·h" value="hour" />
                <el-option label="按天能耗-kW·h" value="day" />
                <el-option label="按周能耗-kW·h" value="week" />
                <el-option label="按月能耗-kW·h" value="month" />
              </el-select>
            </div>
            <ECharts :options="energyOption" class="chart" :height="echartHeight" />
          </div>
          <div class="right-card">
            <div class="card-title">风机运行状态 
              <el-select v-model="deviceC" style="width:100px;" @change="loadYunxingData">
                <el-option label="A库" value="13517" />
                <el-option label="B库" value="13521" />
              </el-select>
            </div>
             <ECharts :options="yunxingOption" class="chart" :height="echartHeight" />
          </div>
        </div>
      </div>
      <div class="mr-visual-footer">
        <v-footer></v-footer>
      </div>
    </div>
  </ScaleBox>
</template>

<script lang="js">
import { mapState } from "vuex";
import VHeaderBox from "./components/v-header-box.vue";
import VFooter from "./components/v-footer.vue";
import ScaleBox from "@/components/view/scaleBox.vue";
import ECharts from '@/components/view/ECharts.vue';
import { DateToShort, DateToHHmm } from "@/utils/util/util";

export default {
  name: 'visual',
  components: {
    VHeaderBox,
    VFooter,
    ScaleBox,
    ECharts
  },
  data() {
    return {
      deviceA: "13517",
      deviceC: "13517",
      screenData: {
        "energyLabel":"--",
        "moneyLabel":"--",
        "qitingLabel":"--",
        "thisJson": {
          "year": "--",
          "energy": "--",
          "money": "--",
          "qiting": "--",
          "energyPercent": "--",
          "moneyPercent": "--",
          "qitingPercent": "--",
          "energyColor": "",
          "moneyColor": "",
          "qitingColor": "",
        },
        "prevJson": {
          "year": "--",
          "energy": "--",
          "money": "--",
          "qiting": "--",
        }
      },
      paramKuwen: {
        deviceId: null,
        date: null,
        project: null,
      },
      paramEnergy: {
        energyFlag: "hour",
        date: null,
        project: null,
      },
      paramYunxing: {
        deviceId: null,
        date: null,
        project: null,
      },
      projectCode: "", 
      echartHeight: "200px",
      kuwenOption: {},
      energyOption: {},
      yunxingOption: {},
      kuwenData: {
        "series": []
      },
      energyData: {
        "series": []
      },
      yunxingData: {
        "series": []
      },
    }
  },
  computed: {
    ...mapState(["projectCurrentRowData"])
  },
  mounted() {
    var projectData = this.projectCurrentRowData || {};
    this.projectCode = projectData.projectCode;
    if (this.projectCode==null||this.projectCode=='') {
      this.$router.push({ path: "/login" });
    } else {
      this.paramKuwen.date=DateToShort(new Date());
      this.paramKuwen.project=this.projectCode;
      this.paramEnergy.project=this.projectCode;
      this.paramEnergy.energyFlag='hour';
      this.paramYunxing.date=DateToShort(new Date());
      this.paramYunxing.project=this.projectCode;
      this.zongHeData();
      this.loadKuwenData();
      this.loadEnergyData();
      this.loadYunxingData();
    }
  },
  methods: {
    initKuwenOption() {
      this.kuwenOption={
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: { color: '#ffffff' },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: { color: '#ffffff' },
        },
        legend: {
          show: true,
          textStyle: { color: '#ffffff' },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: 40,
          right: 20,
          top: 30,
          bottom: 20,
        },
        series: this.kuwenData.series,
      };
    },
    initEnergyOption() {
      this.energyOption={
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: { color: '#ffffff' },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: { color: '#ffffff' },
        },
        legend: {
          show: true,
          textStyle: { color: '#ffffff' },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: 40,
          right: 20,
          top: 30,
          bottom: 20,
        },
        series: this.energyData.series,
      };
    },
    initYunxingOption() {
      this.yunxingOption={
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: { color: '#ffffff' },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: { color: '#ffffff' },
        },
        legend: {
          show: true,
          textStyle: { color: '#ffffff' },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: 40,
          right: 20,
          top: 30,
          bottom: 20,
        },
        series: this.yunxingData.series,
      };
    },
    zongHeData() {
      var params={
          project: this.projectCode
      }
      this.request.freezerZongHe(params).then((res) => {
        if (res.code==0) {
          this.screenData = res.data;
        } 
      });
    },
    loadKuwenData() {
      this.paramKuwen.deviceId=this.deviceA;
      this.request.kuwenData(this.paramKuwen).then((res) => {
        if (res.code==0) {
          this.kuwenData.series=[];
          var items=res.data;
          for (var index=0; index<items.length; index++) {
            var data=[];
            let list=items[index].data;
            if (list!=null&&list.length>0) {
              for (let i=0; i<list.length; i++) {
                var time=DateToHHmm(new Date(parseInt(list[i].time)*1000));
                data.push({"value":[time,list[i].value]});
              }
            }
            var serie={
              "data": data,
              "type": "line",
              "name": items[index].name,
              "smooth": true,
            };
            this.kuwenData.series.push(serie);
          };
          this.initKuwenOption();
        } 
      });
    },
    loadEnergyData() {
      this.request.fengjiData(this.paramEnergy).then((res) => {
        if (res.code==0) {
          this.energyData.series=[];
          var items=res.data;
          for (var index=0; index<items.length; index++) {
            var data=[];
            let list=items[index].data;
            if (list!=null&&list.length>0) {
              for (let i=0; i<list.length; i++) {
                data.push({"value":[list[i].time,list[i].value]});
              }
            }
            var serie={
              "data": data,
              "type": "line",
              "name": items[index].name,
              "smooth": true,
            };
            this.energyData.series.push(serie);
          };
          this.initEnergyOption();
        } 
      });
    },
    loadYunxingData() {
      this.paramYunxing.deviceId=this.deviceC;
      this.request.yunxingData(this.paramYunxing).then((res) => {
        if (res.code==0) {
          this.yunxingData.series=[];
          var items=res.data;
          for (var index=0; index<items.length; index++) {
            var data=[];
            let list=items[index].data;
            if (list!=null&&list.length>0) {
              for (let i=0; i<list.length; i++) {
                var time=DateToHHmm(new Date(parseInt(list[i].time)*1000));
                data.push({"value":[time,list[i].value]});
              }
            }
            var serie={
              "data": data,
              "type": "line",
              "name": items[index].name,
              "smooth": true,
            };
            this.yunxingData.series.push(serie);
          };
          this.initYunxingOption();
        } 
      });
    }
  }
}
</script>
<style scoped lang="scss">

.left-cards {
  width: 370px;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 10px;
}

.right-cards {
  width: 450px;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 10px;
}

.data-card {
  background-color: rgba(30, 41, 59, 0.8);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  margin-top: 20px;
}

.right-card {
  border-radius: 1px;
  margin-top: 20px;
  margin-right: 20px;
}

.card-title {
  font-size: 22px;
  color: white;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trend-down {
  margin-right: 4px;
  color: #22c55e;
  font-size: 18px;
}

.trend-up {
  margin-right: 4px;
  color: red;
  font-size: 18px;
}

.year-data {
  display: flex;
  flex-direction: column;
}

.year-item {
  margin-bottom: 5px;
  margin-top: 15px;
}

.year-label {
  font-size: 20px;
  color: #94a3b8;
  margin-bottom: 10px;
  margin-right: 20px;
}

.year-label2 {
  font-size: 18px;
  color: #94a3b8;
  margin-bottom: 10px;
  margin-right: 20px;
}

.year-value {
  font-size: 22px;
  font-weight: bold;
}

.year-item:nth-child(1) .year-value {
  background: linear-gradient(to right, #7e22ce, #a855f7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.year-item:nth-child(2) .year-value {
  background: linear-gradient(to right, #7e22ce, #a855f7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.year-item:nth-child(3) .year-value {
  background: linear-gradient(to right, #7e22ce, #a855f7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.year-item:nth-child(4) .year-value {
  background: linear-gradient(to right, #7e22ce, #a855f7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.chart {
  width: 100%;
  height: 100px;
  padding: 10px;
  background-color: rgba(30, 41, 59, 0.8);
}

::v-deep .el-input__inner {
  background-color: rgba(31, 51, 89, 0.4) !important; 
  color: #ffffff !important;
  border-color: rgba(31, 51, 89, 1);
}

.v-card {
  height: 100px;
  width: 320px;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 14px;
  border-radius: 1px;
  opacity: 1;
  background: rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  border: 1px solid;
  box-sizing: border-box;
  border-image: linear-gradient(119deg, rgba(0, 255, 200, 0.13) 40%, rgba(207, 236, 255, 0) 70%, rgba(184, 228, 255, 0.32) 112%) ;
  >.vc-list {
    >p {
      text-align: center;
      line-height: 24px;
    }
    >p:nth-child(1) {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 12px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.6);
    }
    >p:nth-child(2) {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 14px;
      letter-spacing: 0em;
      color: #FFFFFF;
      font-weight: 700;
    }
  }
}
.mr-visual {
  height: 100%;
  background: url("./images/zonghe_bg.jpg") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;

  .mr-visual-header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .mr-visual-left,
  .mr-visual-right,
  .mr-visual-container {
    position: absolute;
    height: 100%;
    opacity: 1;
    box-sizing: border-box;

    .scroll {
      height: 100%;

      >div {
        margin-bottom: 8px;
      }
    }
  }

  .mr-visual-container {
    width: 1344px;
    left: 13%;
    height: 100%;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .mr-visual-right {
    top: 70px;
    right: 10px;
    box-sizing: border-box;
  }

  .mr-visual-left {
    top: 70px;
    left: 0;
    box-sizing: border-box;
  }

  .mr-opt-dialog {
    position: absolute;
    left: -78px;
    top: 25%;
  }

  .mr-visual-footer {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
  }

  .popinfos {
    /* 矩形 411 */

    position: absolute;

    width: 264.12px;
    height: 144.56px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    box-shadow: inset 0px 4px 32px 0px rgba(0, 34, 255, 0.45);
    z-index: 1;
    padding: 20px 15px;

    P {
      width: 210px;
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      text-align: left;
      padding-left: 8px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 26px;

      font-weight: 600;
    }
  }
}
</style>
